module.exports = __webpack_public_path__ + "static/media/galdinsWon_75_100.9ce179fc.png";